import * as React from "react";
import { FC, useMemo } from "react";
import classNames from "classnames/dedupe";
import getHighlights from "../../../../helpers/getHighlights";
import { TThemeVariant, useTheme } from "../../../Utility/ThemeProvider";

export interface IHighlightProps {
  text: string;
  highlight: string;
  type?: "primary" | "secondary" | "error";
  variant?: TThemeVariant;
}

const Highlight: FC<IHighlightProps> = ({
  text = "",
  highlight = "",
  type = "primary",
  variant,
}) => {
  const theme = useTheme(variant);

  const highlights = useMemo(
    () => getHighlights(text, highlight),
    [highlight, text],
  );

  const className = useMemo(() => {
    if (theme === "dark") {
      classNames(`bg-color-white`, {
        "text-color-blue": !type || type === "primary",
        "text-color-red": type === "secondary",
        "text-color-error": type === "error",
      });
    }
    return classNames(`text-color-white`, {
      "bg-color-blue": !type || type === "primary",
      "bg-color-red": type === "secondary",
      "bg-color-error": type === "error",
    });
  }, [theme, type]);

  return (
    <>
      {highlights.map((part) =>
        part && highlight && part.toLowerCase() === highlight.toLowerCase() ? (
          <span className={className} data-testid="Highlight" key={part}>
            {part}
          </span>
        ) : (
          part
        ),
      )}
    </>
  );
};

export default Highlight;
